module.exports = __webpack_public_path__ + "static/img/cream.5d55907e.png";